import { defineMessages } from '../translate';

/** Install / update banners and push-subscription messages. */
export default defineMessages('pwa', {
  installTitle: 'Install the app',
  installBody: 'Faster open, works with push.',
  install: 'Install',
  installIosTitle: 'Install on iPhone',
  // {share} is the Share icon; {addToHome} the Safari menu item.
  installIosBody: 'Tap {share} in Safari → {addToHome}. Required for push notifications.',
  share: 'Share',
  addToHomeScreen: '"Add to Home Screen"',
  updateReady: 'A new version of Projoint is ready.',
  updateNow: 'Update now',
  swNotReady: 'Service worker not ready.',
  pushDisabledOnServer: 'Push is disabled on this server.',
  subscribeFailed: 'Subscribe failed',
  unsubscribeFailed: 'Unsubscribe failed',
  subscriptionKeysMissing: 'Subscription missing required keys',
} as const);
